module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1055-e2dfd2978caa076f5c3c539e4cca2251.png";